var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTransactionReports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 18.3333H12.5C16.6666 18.3333 18.3333 16.6667 18.3333 12.5V7.49999C18.3333 3.33332 16.6666 1.66666 12.5 1.66666H7.49996C3.33329 1.66666 1.66663 3.33332 1.66663 7.49999V12.5C1.66663 16.6667 3.33329 18.3333 7.49996 18.3333Z",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 15.4167C13.8333 15.4167 14.5833 14.6667 14.5833 13.75V6.25001C14.5833 5.33334 13.8333 4.58334 12.9167 4.58334C12 4.58334 11.25 5.33334 11.25 6.25001V13.75C11.25 14.6667 11.9917 15.4167 12.9167 15.4167Z",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08329 15.4167C7.99996 15.4167 8.74996 14.6667 8.74996 13.75V10.8333C8.74996 9.91666 7.99996 9.16666 7.08329 9.16666C6.16663 9.16666 5.41663 9.91666 5.41663 10.8333V13.75C5.41663 14.6667 6.15829 15.4167 7.08329 15.4167Z",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactionReports);
export default __webpack_public_path__ + "static/media/ic_transaction_reports.37e8033d4b829c5a17d39ed3426dd1dd.svg";
export { ForwardRef as ReactComponent };